export enum UiComponentPrimaryClickAction {
  LINK = 'link',
}
